/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineMail, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOneEmail } from "../../lib/sysNavigation/SysNavigation";

type TemplateRow = {
  email_templates_id: number | string;
  title?: string;
  message?: string;
  [key: string]: unknown;
};

const editRoute = "/email/edit";

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { emailTemplates, getEmailTemplates } = useStaticContext() as any;

  useEffect(() => {
    if (!emailTemplates) getEmailTemplates();
  }, [emailTemplates]);

  const rows = useMemo<TemplateRow[] | null>(() => {
    if (!Array.isArray(emailTemplates)) return null;
    return emailTemplates as TemplateRow[];
  }, [emailTemplates]);

  const columns: Column<TemplateRow>[] = [
    {
      header: "Title",
      cell: (row) => (
        <span className="font-medium text-gray-900">{row.title ?? "—"}</span>
      ),
    },
    {
      header: "Message",
      cell: (row) => (
        <span className="line-clamp-2 text-gray-600">{row.message ?? "—"}</span>
      ),
    },
  ];

  const rowActions = (row: TemplateRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneEmail(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<TemplateRow>
      title="Email Templates"
      subtitle="Reusable messages sent from the platform."
      icon={<HiOutlineMail className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.email_templates_id}
      rowActions={rowActions}
      empty="No email templates yet."
    />
  );
};

export default Overview;
